import Button from '@mui/material/Button';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import useVoteComponent from '../../../hooks/useVoteComponent';
import { Question } from '../../../types';
import useVoteComponentStyles from './useVoteComponentStyles';

/**
 * Interface represents the props for the VoteComponent.
 *
 * question - The question object containing voting information.
 */
interface VoteComponentProps {
  question: Question;
}

/**
 * A Vote component that allows users to upvote or downvote a question.
 *
 * @param question - The question object containing voting information.
 */
const VoteComponent = ({ question }: VoteComponentProps) => {
  const { classes } = useVoteComponentStyles();

  const { voted, handleVote, count } = useVoteComponent(question);

  return (
    <div className={classes.voteContainer}>
      <Button
        className={`${classes.voteButton} ${voted === 1 ? classes.voteButtonUpvoted : classes.notVotedButton}`}
        onClick={() => handleVote('upvote')}>
        <ThumbUpIcon />
      </Button>
      <Button
        className={`${classes.voteButton} ${voted === -1 ? classes.voteButtonDownvoted : classes.notVotedButton}`}
        onClick={() => handleVote('downvote')}>
        <ThumbDownIcon />
      </Button>
      <span className={classes.voteCount}>{count}</span>
    </div>
  );
};

export default VoteComponent;
